module.exports = __webpack_public_path__ + "img/IMG_9321_L_WoodMatted.48bd0ad3.jpg";